import { useEffect, useState } from "react"
import { delay } from "lib/delay"
import { isScheduleCodeInUse } from "../controller/is-schedule-code-in-use"

const CODE_CHECK_DEBOUNCE_MS = 350

export function useScheduleCodeAvailabilityCheck({ code, excludeScheduleId, projectId, onAvailabilityChange }) {
    const [codeError, setCodeError] = useState(null)
    const trimmedCode = code?.trim()

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(checkCodeAvailability, [trimmedCode])

    return codeError

    function checkCodeAvailability() {
        let cancelled = false
        runCheck()
        return function cancel() {
            cancelled = true
        }

        async function runCheck() {
            if (!trimmedCode) {
                setCodeError(null)
                onAvailabilityChange(false)
                return
            }

            setCodeError(null)
            onAvailabilityChange(true)

            await delay(CODE_CHECK_DEBOUNCE_MS)
            if (cancelled) return

            let inUse
            try {
                inUse = await isScheduleCodeInUse(trimmedCode, excludeScheduleId, projectId)
            } catch (error) {
                if (cancelled) return
                console.error("[authoring] Failed to check schedule code availability", error)
                setCodeError("Could not check if this code is available. Please try again.")
                onAvailabilityChange(false)
                return
            }
            if (cancelled) return

            setCodeError(inUse ? `A schedule with code "${trimmedCode}" already exists` : null)
            onAvailabilityChange(inUse)
        }
    }
}
